import ApiClient from './ApiClient';

const apiClient = ApiClient('/crane_systems');

export const createCraneSystem = (payload, onSuccess, onError, onDone) => {
    apiClient.post('/', payload).then(onSuccess).catch(onError).finally(onDone);
};

export const updateCraneSystem = (craneSystemId, payload, onSuccess, onError, onDone) => {
    apiClient.put(`/${craneSystemId}/`, payload).then(onSuccess).catch(onError).finally(onDone);
};

export const upsertCraneSystem = (payload, onSuccess, onError, onDone) => {
    const craneSystemId = payload.id;
    delete payload.id;
    if (craneSystemId) updateCraneSystem(craneSystemId, payload, onSuccess, onError, onDone);
    else createCraneSystem(payload, onSuccess, onError, onDone);
};

export const deleteCraneSystem = (craneSystemId, onSuccess, onError, onDone) => {
    apiClient.delete(`/${craneSystemId}/`).then(onSuccess).catch(onError).finally(onDone);
};

export const getCraneSystemsList = (customerId, siteId, locationId, onSuccess, onError, onDone) => {
    let url = '/';
    const params = [];
    if (customerId) params.push(`customer_id=${customerId}`);
    if (siteId) params.push(`site_id=${siteId}`);
    if (locationId) params.push(`location_id=${locationId}`);
    if (params.length) url += '?' + params.join('&');
    apiClient.get(url).then(onSuccess).catch(onError).finally(onDone);
};
